import {InstagramIcon} from "../common/Icons";
import React from "react";
import {Link} from "react-router-dom";
import Picture from "../common/Picture";

interface FooterProps {
    onMenuOpen: () => void;
}

const Footer: React.FC<FooterProps> = ({onMenuOpen}) => {
    return (
        <footer className="snap-section h-auto bg-royal-pine text-ivory text-opacity-70 relative">
            <div className="container mx-auto pt-24 pb-12 px-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center md:text-left">
                    <div className="space-y-4">
                        <Picture
                            webpSrc="/images/logo.webp"
                            pngSrc="/images/logo.png"
                            alt="All Aces Club Logo"
                            className="h-16 w-auto mx-auto md:mx-0"
                        />
                        <div className="flex space-x-4 justify-center md:justify-start">
                            <Link
                                to="https://www.instagram.com/allacesclub"
                                className="flex items-center gap-2 hover:text-logo-color transition-colors"
                            >
                                <InstagramIcon/>
                                Instagram
                            </Link>
                        </div>
                    </div>
                    <div>
                        <h3 className="heading-font text-lg font-semibold text-ivory mb-4">MAIN SITE</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/" className="hover:text-logo-color transition-colors">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <button onClick={onMenuOpen} className="hover:text-logo-color transition-colors">
                                    The Club Experience
                                </button>
                            </li>
                            <li>
                                <Link to="/hospitality" className="hover:text-logo-color transition-colors">
                                    Hospitality
                                </Link>
                            </li>
                            <li>
                                <Link to="/membership" className="hover:text-logo-color transition-colors">
                                    Membership
                                </Link>
                            </li>
                            <li>
                                <Link to="/connect" className="hover:text-logo-color transition-colors">
                                    Connect
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="heading-font text-lg font-semibold text-ivory mb-4">OFFICE HOURS</h3>
                        <ul className="space-y-2">
                            <li>All days open</li>
                            <li>11:00 am - 7:00 pm</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="heading-font text-lg font-semibold text-ivory mb-4">CONTACT INFO</h3>
                        <ul className="space-y-2">
                            <li>Sector-79 Faridabad, Haryana</li>
                            <li>
                                <a
                                    href="mailto:contact@allacesclub.com"
                                    className="hover:text-logo-color transition-colors"
                                >
                                    contact@allacesclub.com
                                </a>
                            </li>
                            <li>
                                <a
                                    href="tel:+919310821204"
                                    className="hover:text-logo-color transition-colors"
                                >
                                    +91 93108 21204
                                </a>
                            </li>
                            <li>
                                <a
                                    href="tel:+919311101204"
                                    className="hover:text-logo-color transition-colors"
                                >
                                    +91 93111 01204
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    className="mt-12 border-t border-muted-sage border-opacity-30 pt-8 flex flex-col text-sm">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p>&copy; {new Date().getFullYear()} All Aces Club. All Rights Reserved.</p>
                        <div className="flex space-x-4 mt-4 md:mt-0">
                            <a href="#" className="hover:text-logo-color transition-colors">Terms</a>
                            <a href="#" className="hover:text-logo-color transition-colors">Privacy</a>
                        </div>
                    </div>
                    <p className="text-xs text-ivory/80 my-6">
                        <strong>Disclaimer:</strong> All images displayed on this website are for reference and
                        illustrative purposes only. Actual products, facilities, and services may vary in
                        appearance, design and specifications.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;